import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import {
  LocationOfDevicesUnrelatedToRoadOccupationStageForm,
  LocationOfDevicesUnrelatedToRoadOccupationStageFormValue,
  toStageFormValue
} from './location-of-devices-unrelated-to-road-occupation-stage.form';
import { RoadOccupationAppEntityApplicationRead } from '../../../../../../../openapi';

export function occupationsToFormValue(occupations: Array<RoadOccupationAppEntityApplicationRead>): LocationOfDevicesUnrelatedToRoadOccupationFormValue[] {
  return occupations.map(v => {
    return {
      locationDecisionNumber: v?.locationDecisionNumber || '',
      locationDecisionDate: v?.locationDecisionDate || null,
      deviceType: v?.deviceType || '',
      stages: v?.stages?.map(v => toStageFormValue(v)) || []
    };
  });
}

export interface LocationOfDevicesUnrelatedToRoadOccupationFormValue {
  locationDecisionNumber: string;
  locationDecisionDate: Date | null;
  deviceType: string;
  stages: LocationOfDevicesUnrelatedToRoadOccupationStageFormValue[];
}

@Injectable()
export class LocationOfDevicesUnrelatedToRoadOccupationForm extends AppForm {

  constructor() {
    super({
      deviceType: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      locationDecisionNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      locationDecisionDate: new FormControl(null, {
        validators: [CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date()), Validators.required]
      }),
      stages: new FormArray([
        new LocationOfDevicesUnrelatedToRoadOccupationStageForm()
      ])
    });
  }

  public addStage(): void {
    this.stages.push(new LocationOfDevicesUnrelatedToRoadOccupationStageForm());
  }

  public removeStage(i: number): void {
    this.stages.removeAt(i);
  }

  public get stages(): FormArray {
    return this.get('stages') as FormArray;
  }

  public getStageForms(): LocationOfDevicesUnrelatedToRoadOccupationStageForm[] {
    return this.stages.controls as LocationOfDevicesUnrelatedToRoadOccupationStageForm[];
  }

  public override get valid(): boolean {
    return super.valid && !!this.stages.controls.map(c => c.valid).filter(v => v).length;
  }

  public override patchFormValues(value: LocationOfDevicesUnrelatedToRoadOccupationFormValue): void {
    super.patchFormValues(value);
    this.stages.clear();
    (value?.stages || []).forEach(stage => {
      const sf = new LocationOfDevicesUnrelatedToRoadOccupationStageForm();
      sf.patchFormValues(stage);
      this.stages.push(sf);
    });
  }

  public get values(): LocationOfDevicesUnrelatedToRoadOccupationFormValue {
    return {
      ...this.value,
      stages: this.getStageForms().map(v => v.values)
    };
  }
}
